import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from "react-router-dom";
import { Spin, Row, Col, Button, Select, Tooltip, Modal, Checkbox, message } from 'antd';
import { find } from 'lodash';
import dayjs from 'dayjs';

import {
    loadIncidents,
    setSelectedYear,
} from '../actions';
import * as constants from '../constants';

import uistate from '../../uistate';
import common from '../../../common';
import core from '../../core';
import currentuser from '../../currentuser';
import globalappstate from '../../globalappstate';

const { AgGridWithState } = core;
const { currentUserHasRights, RendererBoolean, RendererStatus } = common;

const dateFormatter = (params) => {
    if (params.value) {
        return dayjs(params.value).format('DD-MM-YYYY');
    } else {
        return '';
    }
}
class IncidentsGrid extends Component {

    state = {
        selectedIdIncident: 0,
        currentEditEntity: {},
        editFormVisible: false,
    }

    constructor(props) {
        super(props);
    }

    UNSAFE_componentWillMount() {
        this.props.loadIncidents(this.props.selectedYear);
    }
    componentWillUnmount() {
        if (this.gridApi) {
            var columnState = this.gridApi.getColumnState()
            var filterModel = this.gridApi.getFilterModel()
            this.props.saveGridFilters('IncidentsGrid', { columnState, filterModel })
        }
    }

    label = (key) => {
        return common.getLabel(this.props.labels, constants.NAME, 'IncidentsGrid', key);
    }
    nrFormatter = (params) => {
        if (params.value) {
            return Number(params.value).toLocaleString('nl-NL', { style: 'currency', currency: 'EUR', minimumFractionDigits: 2, maximumFractionDigits: 2 });
        } else {
            return ''
        }
    }
    refreshClicked = () => {
        this.props.loadIncidents(this.props.selectedYear);
    }

    getGridCols = () => {
        let cols = [
            { key: "statusText", headerName: this.label("Status"), field: "statusText", sortable: true, filter: false, enableRowGroup: true, suppressHeaderMenuButton: true, width: 80, minWidth: 80, maxWidth: 80 },
            { key: "number", width: 110, minWidth: 110, maxWidth: 110, headerName: this.label("Number"), field: "number", sortable: true, filter: true, enableRowGroup: true, suppressHeaderMenuButton: true, filter: "agTextColumnFilter" },
            { key: "company", headerName: this.label("Company"), field: "company", sortable: true, filter: true, enableRowGroup: true, suppressHeaderMenuButton: true },
            { key: "subject", headerName: this.label("Subject"), field: "subject", sortable: true, filter: true, enableRowGroup: true, suppressHeaderMenuButton: true, filter: "agTextColumnFilter" },
            { key: "description", headerName: this.label("Description"), field: "description", sortable: true, filter: true, enableRowGroup: true, suppressHeaderMenuButton: true, filter: "agTextColumnFilter" },
            { key: "summary", headerName: this.label("Summary"), field: "summary", sortable: true, filter: true, enableRowGroup: true, suppressHeaderMenuButton: true, filter: "agTextColumnFilter" },
            { key: "type", width: 70, headerName: this.label("Type"), field: "type", sortable: true, filter: true, enableRowGroup: true, suppressHeaderMenuButton: true },
            { key: "date", width: 110, minWidth: 110, maxWidth: 110, headerName: this.label("Date"), field: "date", sortable: true, filter: true, enableRowGroup: false, suppressHeaderMenuButton: true, filter: "agTextColumnFilter", valueFormatter: dateFormatter },
        ]

        return cols;
    }

    onGridReady = (params) => {
        this.gridApi = params.api;


        if (this.props.gridfilterstate) {
            this.gridApi.applyColumnState({ state: this.props.gridfilterstate.columnState, applyOrder: true });
            this.gridApi.setFilterModel(this.props.gridfilterstate.filterModel);
        }
    };
    deselectAll = () => {
        if (this.gridApi) {
            this.gridApi.deselectAll()
        }
    }

    //#region Grid/Button handlers

    handleChangeYear = (value) => {
        this.props.setSelectedYear(value);
        this.props.loadIncidents(value);
    }
    
    onDoubleClick = async (dataitem) => {
        this.props.history.push(`/app/incidents/${dataitem.idIncident}`)
    }
    onSelect = async (dataitem) => {
        this.setState({
            selectedIdIncident: dataitem.idIncident,
        });
    }

    //#endregion

    render() {
        const loading = this.props.loadingIncidents;
        const menuHeight = 45
        const gridHeight = this.props.contentHeight - menuHeight;
        const columnDefinitions = this.getGridCols();

        return (
            <div className='incidents'>
                <Row className='main-toolbar' style={{ height: menuHeight }} justify='start' align='middle' gutter={8}>
                    <Col span={24} >
                        <span className='module-title'>{this.label("Incidents")}</span>
                        <span style={{ margin: 5, marginLeft: 25 }}>{this.label("Year")}</span>
                        <Select onChange={this.handleChangeYear} value={this.props.selectedYear}>
                            {
                                this.props.picklists.years ? this.props.picklists.years.map(o => <Select.Option key={o.id} value={o.id}>{o.name}</Select.Option>) : null
                            }
                        </Select>
                    </Col>
                </Row>
                {loading ? (
                    <div className="loader-content" >
                        <Spin size="large" />
                        <p>{this.label("Loading")}</p>
                    </div>
                ) : (
                    <>
                        <AgGridWithState height={gridHeight} ShowGroupPanel={true}
                            lang={this.props.curLanguage}
                            onReady={this.onGridReady}
                            onItemSelected={this.onSelect}
                            onItemDoubleClicked={this.onDoubleClick}
                            columnDefinitions={columnDefinitions}
                            data={this.props.incidents}
                            onRefresh={this.refreshClicked}
                            labels={this.props.labels}
                            frameworkComponents={{
                                'rendererBoolean': RendererBoolean, 'rendererStatus': RendererStatus
                            }}
                        >
                        </AgGridWithState>
                    </>
                )}
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        loadingIncidents: state[constants.NAME].loadingIncidents,
        incidents: state[constants.NAME].incidents,
        selectedYear: state[constants.NAME].selectedYear,
        contentHeight: state[uistate.constants.NAME].contentheight,
        labels: uistate.selectors.uiLabels(state),
        curLanguage: uistate.selectors.curLanguage(state),
        currentuser: state[currentuser.constants.NAME],
        picklists: globalappstate.selectors.allPicklists(state),
        gridfilterstate: state[uistate.constants.NAME].gridfilterstate['IncidentsGrid'],
    };
}

export default connect(mapStateToProps,
    {
        loadIncidents,
        setSelectedYear,
        saveGridFilters: uistate.actions.saveGridFilters
    })(IncidentsGrid);